import {StartupService} from "./startup.service";

export class StartupFactory {
  public static StartupService(service: StartupService): () => void {
    return () => service.initialize();
  }
}
